import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        <Link to="/" className="font-display text-3xl inline-block mb-10">Sanctum</Link>
        <XCircle className="w-14 h-14 text-neutral-400 mx-auto mb-6" strokeWidth={1.2} />
        <h1 className="font-display text-3xl">Checkout cancelled.</h1>
        <p className="text-neutral-500 mt-3">No worries — the song is still waiting.</p>
        <Link to="/store" data-testid="back-to-store" className="btn-pill btn-primary mt-8 inline-flex">Back to store</Link>
      </div>
    </div>
  );
}
